var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['app_outer_wrap', _vm.is_app_ie_class ? 'app_ie' : ''],attrs:{"id":"app"},on:{"click":_vm.allClick,"scroll":_vm.handleScroll}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }